import { theme } from '@frontend/theme';
import { FontColorType, TextSize } from '@frontend/design-system';
import { QuickFilterCardVariant } from './types';

export const variantStyles: Record<
  QuickFilterCardVariant,
  { borderColor: string; textColor: FontColorType; textSize: TextSize; padding: string }
> = {
  card: {
    borderColor: theme.colors.neutral30,
    textColor: 'subdued',
    textSize: 'medium',
    padding: theme.spacing(0.5, 1.5),
  },
  compactCard: {
    borderColor: theme.colors.neutral50,
    textColor: 'default',
    textSize: 'small',
    padding: theme.spacing(0.25, 1),
  },
};
export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  item: (variant: QuickFilterCardVariant, isActive?: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    gap: theme.spacing(0.5),
    padding: variantStyles[variant].padding,
    border: `1px solid ${isActive ? theme.colors.primary5 : variantStyles[variant].borderColor}`,
    borderRadius: theme.borderRadius.small,
    backgroundColor: isActive ? theme.colors.primary5 : 'transparent',
    '&:hover': {
      backgroundColor: isActive ? theme.colors.primary5 : theme.colors.neutral10,
    },
    '&:active': {
      borderColor: isActive ? theme.colors.primary5 : theme.colors.neutral90,
    },
  }),
  countBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 16,
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.borderRadius.full,
    backgroundColor: theme.colors.critical50,
    color: theme.colors.white,
  },
};
